import React, { useRef, useState } from 'react';

import { SearchResultsHeadless, SearchConfigure, getSearchFiltersParameter } from '@uncinc/react-searchkit';
import type { SearchParameters } from '@uncinc/react-searchkit/types';
import { Map } from 'leaflet';

import { APP_OPTIONS } from '../../config/constants';
import MapWithSearchResults from './components/LeafletMap';
import ProjectMapSearchkitWrapper from './components/SearchkitWrapper';
import Sidebar from './components/Sidebar';
import type { SearchResult, LeafletMapProps } from './types';

import './style.scss';

const ProjectMap: React.FC<Pick<LeafletMapProps, 'defaultMarker'>> = (props) => {
  const { defaultMarker } = props;

  const mapRef = useRef<Map>(null);
  const [searchParameters, setSearchParameters] = useState<SearchParameters>({ filters: '', page: 0 });

  return (
    <div className="ProjectMap">
      <ProjectMapSearchkitWrapper
        onStateChange={({
          uiState,
          setUiState,
        }) => {
          const indexUiState = uiState[APP_OPTIONS.parameters.searchkitIndexAllProjects];

          // Copy over the filters from this search to the map search.
          setSearchParameters((prevSearchParameters) => {
            const filters = getSearchFiltersParameter(indexUiState || {});

            // If the filters haven't changed, we don't want to trigger
            // a search parameter change, so return the previous state.
            // This is also done to prevent unnecessary rerenders of the
            // map, triggered by other uiState changes.
            if (prevSearchParameters.filters === filters) {
              return prevSearchParameters;
            }

            return {
              filters,
              page: 0,
            };
          });

          // Continue with this search.
          setUiState(uiState);
        }}
      >
        <Sidebar mapRef={mapRef} />
        <div className="ProjectMap__map">
          <ProjectMapSearchkitWrapper>
            <SearchConfigure {...searchParameters} />
            <SearchResultsHeadless loadAllPages>
              {(hits) => (
                <MapWithSearchResults
                  mapRef={mapRef}
                  defaultMarker={defaultMarker}
                  hits={hits as SearchResult[]}
                />
              )}
            </SearchResultsHeadless>
          </ProjectMapSearchkitWrapper>
        </div>
      </ProjectMapSearchkitWrapper>
    </div>
  );
};

export default ProjectMap;
